import { render, staticRenderFns } from "./MessageAdd.vue?vue&type=template&id=0b57fd1b"
import script from "./MessageAdd.vue?vue&type=script&lang=js"
export * from "./MessageAdd.vue?vue&type=script&lang=js"
import style0 from "./MessageAdd.vue?vue&type=style&index=0&id=0b57fd1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports